import { tg } from "./telegram";

export type GameId =
  | "wordle"
  | "connections"
  | "contexto"
  | "worldle"
  | "flaggle"
  | "redactle"
  | "travle"
  | "hariache"
  | "susidy"
  | "stolytsia"
  | "queens"
  | "stado"
  | "chrono"
  | "mathle"
  | "slovko"
  | "persondle"
  | "emovi"
  | "bilshe"
  | "khaip"
  | "mat"
  | "dezze"
  | "gerb"
  | "zblyzka"
  | "vahon"
  | "foto"
  | "slova"
  | "slovokolo"
  | "rebus"
  | "stavky"
  | "kviz"
  | "taemne"
  | "maliunok"
  | "dviinyk"
  | "khvylia"
  | "naoko"
  | "arena";
export const GAME_IDS: GameId[] = [
  "wordle",
  "connections",
  "contexto",
  "worldle",
  "flaggle",
  "redactle",
  "travle",
  "hariache",
  "susidy",
  "stolytsia",
  "queens",
  "stado",
  "chrono",
  "mathle",
  "slovko",
  "persondle",
  "emovi",
  "bilshe",
  "khaip",
  "mat",
  "dezze",
  "gerb",
  "zblyzka",
  "vahon",
  "foto",
  "slova",
  "slovokolo",
  "rebus",
  "stavky",
  "kviz",
  "taemne",
  "maliunok",
  "dviinyk",
  "khvylia",
  "naoko",
  "arena",
];

/** Hub sections, render order = this order. Every GameId must appear exactly once (compile-checked below, partition-checked in tests). */
export const HUB_GROUPS = [
  { title: "СЛОВА", games: ["wordle", "connections", "slovko", "contexto", "redactle", "slova", "slovokolo", "rebus"] },
  { title: "СВІТ", games: ["worldle", "flaggle", "travle", "hariache", "susidy", "stolytsia"] },
  { title: "УКРАЇНА", games: ["dezze", "gerb", "zblyzka"] },
  { title: "ЛЮДИ Й КІНО", games: ["persondle", "foto", "emovi"] },
  { title: "ЧИСЛА Й ЛОГІКА", games: ["mathle", "mat", "queens", "chrono", "bilshe", "khaip", "naoko"] },
  { title: "РАЗОМ", games: ["vahon", "stado", "stavky", "kviz", "taemne", "maliunok", "dviinyk", "khvylia", "arena"] },
] as const satisfies readonly { title: string; games: readonly GameId[] }[];

type Grouped = (typeof HUB_GROUPS)[number]["games"][number];
// A compile error on the next line names the GameIds missing from HUB_GROUPS.
export const HUB_GROUPS_COVER_ALL: Exclude<GameId, Grouped> extends never ? true : Exclude<GameId, Grouped> = true;

export const GAME_META: Record<GameId, { title: string; emoji: string; blurb: string }> = {
  wordle: { title: "WORDLE", emoji: "🟩", blurb: "слово дня від NYT, 6 спроб" },
  connections: { title: "CONNECTIONS", emoji: "🟪", blurb: "16 слів NYT - знайди 4 групи по 4" },
  contexto: { title: "CONTEXTO", emoji: "🧠", blurb: "вгадай слово за змістом" },
  worldle: { title: "WORLDLE", emoji: "🌍", blurb: "вгадай країну за силуетом" },
  flaggle: { title: "FLAGGLE", emoji: "🏁", blurb: "вгадай прапор по збігу кольорів" },
  redactle: { title: "REDACTLE", emoji: "📰", blurb: "вгадай статтю з Вікіпедії" },
  travle: { title: "TRAVLE", emoji: "🧭", blurb: "доїдь від країни до країни через сусідів" },
  hariache: { title: "ГАРЯЧЕ-ХОЛОДНО", emoji: "🌡️", blurb: "вгадай країну - карта підказує теплом" },
  susidy: { title: "СУСІДИ", emoji: "🤝", blurb: "назви всіх сусідів країни дня" },
  stolytsia: { title: "СТОЛИЦЯ", emoji: "🏛️", blurb: "одна країна - назви її столицю" },
  queens: { title: "КОРОЛЕВИ", emoji: "👑", blurb: "розстав королев по кольорах - на час" },
  stado: { title: "СТАДО", emoji: "🐑", blurb: "вгадай, що обере більшість чату" },
  chrono: { title: "CHRONO", emoji: "📅", blurb: "розстав 5 речей по роках" },
  mathle: { title: "MATHLE", emoji: "🧮", blurb: "склади вираз, що дорівнює цілі дня" },
  slovko: { title: "СЛОВКО", emoji: "🇺🇦", blurb: "українське слово дня, 6 спроб" },
  persondle: { title: "ХТО ЦЕ?", emoji: "🕵️", blurb: "вгадай відому людину за підказками" },
  emovi: { title: "ЕМОВІ", emoji: "🎬", blurb: "вгадай фільм за емодзі" },
  bilshe: { title: "БІЛЬШЕ-МЕНШЕ", emoji: "⚖️", blurb: "більше чи менше? метрика дня, 10 раундів" },
  khaip: { title: "ХАЙП", emoji: "📈", blurb: "кого читають більше - Мадонну чи Львів?" },
  mat: { title: "МАТ ДНЯ", emoji: "♟️", blurb: "знайди мат — 3 життя" },
  dezze: { title: "ДЕ ЦЕ?", emoji: "📍", blurb: "вгадай область за фото" },
  gerb: { title: "ГЕРБ ДНЯ", emoji: "🛡️", blurb: "вгадай місто за гербом" },
  zblyzka: { title: "ЗБЛИЗЬКА", emoji: "🔍", blurb: "що це? камера відʼїжджає з кожним промахом" },
  vahon: { title: "ВАГОНЕТКА", emoji: "🚋", blurb: "дилема дня — правильної відповіді немає" },
  foto: { title: "ХТО НА ФОТО?", emoji: "🖼️", blurb: "впізнай людину — камера відʼїжджає" },
  slova: { title: "СЛОВА ЗІ СЛОВА", emoji: "🔤", blurb: "склади 5 слів з літер довгого слова" },
  slovokolo: { title: "СЛОВОКОЛО", emoji: "🎡", blurb: "проведи слова по колесу літер у кросворд" },
  rebus: { title: "РЕБУС", emoji: "🧩", blurb: "прислів'я, зашифроване в емодзі" },
  stavky: { title: "СТАВКИ", emoji: "🎰", blurb: "одне питання - постав число наосліп" },
  kviz: { title: "КВІЗ", emoji: "⚡", blurb: "5 питань, бали за точність і швидкість" },
  taemne: { title: "ТАЄМНЕ СЛОВО", emoji: "🗝️", blurb: "один описує - решта вгадують" },
  maliunok: { title: "МАЛЮНОК", emoji: "🎨", blurb: "намалюй своє слово — вгадуй малюнки друзів" },
  dviinyk: { title: "ДВІЙНИК", emoji: "👥", blurb: "вгадай, хто з чату що написав учора" },
  khvylia: { title: "ХВИЛЯ", emoji: "🌊", blurb: "одна підказка - вгадай точку на шкалі" },
  naoko: { title: "НА ОКО", emoji: "📏", blurb: "вгадай розмір предмета, 5 раундів" },
  arena: { title: "АРЕНА", emoji: "🏟️", blurb: "живий квіз - всі одночасно" },
};

export type Route = { kind: "hub" } | { kind: "game"; game: GameId } | { kind: "menu" };

/** start_param "<game>_<chatId>" or "hub_<chatId>" inside Telegram; ?game= for dev. */
export function currentRoute(): Route {
  const sp = tg()?.initDataUnsafe?.start_param ?? new URLSearchParams(location.search).get("game") ?? "";
  const id = sp.split("_")[0] ?? "";
  if (id === "hub") return { kind: "hub" };
  if ((GAME_IDS as string[]).includes(id)) return { kind: "game", game: id as GameId };
  return { kind: "menu" };
}
